import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas';
import { debug } from 'console';
import { ReportServiceProxy } from 'shared/service-proxies/services/report.service';
import { GeneratePdf } from 'shared/service-proxies/models/generate-pdf.model';

@Injectable({
    providedIn: 'root'
})
export class DocumentService {
    generateData: GeneratePdf = new GeneratePdf;
    constructor(
        private reportServiceProxy: ReportServiceProxy,
    ) { }

    captureScreen(data, employees, name) {
        html2canvas(data as any).then(canvas => {
            var imgWidth = 210;
            var pageHeight = 295;
            var imgHeight = canvas.height * imgWidth / canvas.width;
            // var heightLeft = imgHeight;
            const contentDataURL = canvas.toDataURL('image/png');
            let pdfData = new jsPDF('p', 'mm', 'a4',true);
            // var position = 0;
            // pdfData.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
            // pdfData.save(`${employees}_${name}.pdf`);

            var heightLeft = imgHeight;
            var position = 0;
            pdfData.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdfData.addPage();
                pdfData.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            pdfData.save(`${employees}_${name}.pdf`);
        });
    }
}